function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Livello_1"
});

var SvgArrowSx = function SvgArrowSx(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "67px",
    height: "47px",
    viewBox: "0 0 67 47",
    style: {
      enableBackground: "new 0 0 67 47"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Livello_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBCA00"
    },
    d: "M43.5,47h-20C10.6,47,0,36.4,0,23.5v0C0,10.6,10.6,0,23.5,0h20C56.4,0,67,10.6,67,23.5v0 C67,36.4,56.4,47,43.5,47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M45.6,22.1H24.9l6.4-6.4c0.6-0.6,0.6-1.5,0-2c-0.6-0.6-1.5-0.6-2,0l-8.9,8.9c-0.6,0.6-0.6,1.5,0,2 l8.9,8.9c0.3,0.3,0.6,0.4,1,0.4c0.4,0,0.7-0.1,1-0.4c0.6-0.6,0.6-1.5,0-2l-6.4-6.4h20.7c0.8,0,1.4-0.6,1.4-1.4 C47,22.7,46.4,22.1,45.6,22.1"
  })), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowSx, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-sx.c8fd78a9.svg";
export { ForwardRef as ReactComponent };